<template>
    <div>
        

        <a-row >

            <a-col :span="18">
                <a-row style="text-align:center;margin-top:20px;margin-left: 20px;margin-right: 20px;" :gutter="20">
                    <a-col :span="5">
                        <a-card>
                            <a-statistic title="名下商家" :value="index.MemberNum" style="margin-right: 50px" >
                                <template #prefix>
                                    <team-outlined />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="5">
                        <a-card>
                            <a-statistic title="名下店铺"  :value="index.ShopNum" >
                                <template #prefix>
                                    <shop-outlined />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="5">
                        <a-card>
                            <a-statistic title="今日单数"   :value="index.OrderNum">
                                <template #prefix>
                                    <flag-outlined />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="9">
                        <a-card>
                        <a-row>
                            <a-col :span="12">
                                
                                    <a-statistic title="账户余额" :precision="2" :value="index.Balance" >
                                        <template #prefix>
                                            ￥
                                        </template>
                                    </a-statistic>
 
                            </a-col>
                            <a-col :span="12">
                                <div><span style="color:rgba(0, 0, 0, 0.45)">钱包ID</span></div>
                                <div style="padding-top: 12px;padding-left: 10px;">
                                    <a-tag   color="#2db7f5">{{ index.WalletId }}</a-tag>

                                </div>
                            </a-col>
                            
                        </a-row>
                    </a-card>

                    </a-col>
                </a-row>
                <a-row  type="flex" style="padding:30px;height:300px" :gutter="20">
                    <a-col flex="484px">
                        <a-card title="我的佣金">
                            <a-tag style="margin-top:5px;margin-bottom:5px;width:130px" v-for="item in commissionList" color="processing" :key="item.Id">≤ {{item.Key}} ￥{{item.Value}}</a-tag>
                        </a-card>
                    </a-col>
                    <a-col flex="auto">
                        <a-card title="提现记录">
                            <template #extra>
                                <a-button @click="withdraw" type="">提现</a-button>
                                <a-button @click="zhuanAction" style="margin-left: 20px;" type="primary">转账</a-button>
                                
                            </template>

                            <a-table :loading="loading"  @change="handleTableChange" :pagination="pagination" :dataSource="list" :columns="columns" >
                                <template #bodyCell="{ column, text }">
                                    <template v-if="column.key === 'status'">
                                        <a-tag color="warning" v-if="text==1">等待审核</a-tag>
                                        <a-tag color="success" v-else-if="text==2">成功</a-tag>
                                        <a-tag color="error" v-else>失败</a-tag>
                                    </template>
                                    <template v-else-if="column.key === 'moneyText'" >
                                        <span style="font-weight:600">
                                            ￥ {{text}}
                                        </span>
                                    </template>
                                </template>
                            </a-table>

                        </a-card>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="6">
                <a-card title="站点配置" style="margin-top:20px">
                    <a-form :model="config" :label-col="labelCol"  :wrapper-col="{ span: 14, offset: 2 }">
                        <!-- <a-form-item label="站点名称">
                            <a-input v-model:value="config.siteName" />
                        </a-form-item> -->
                        <!-- <a-form-item label="站点域名">
                            <a-input v-model:value="config.siteName" />
                        </a-form-item> -->
                        <a-form-item label="邀请链接">
                            <a  target="_blank" :href="config.invitationUrl">{{config.invitationUrl}}</a>
                        </a-form-item>
                        <a-form-item label="邀请码">
                            <a-input v-model:value="config.invitationCode" />
                        </a-form-item>
                        <a-form-item label="客服电话">
                            <a-input v-model:value="config.service" />
                        </a-form-item>
                        <a-form-item label="客服微信">
                            <a-upload
                                name="avatar"
                                list-type="picture-card"
                                class="avatar-uploader"
                                :show-upload-list="false"
                                :action="baseUrl+'/agent/PushImg'" :custom-request="ossDirectUpload"
                                @change="weChatHandleChange"
                                accept="image/jpeg,image/png">
                                <img style="width:100%;height:100%" v-if="config.weChatUrl" :src="config.weChatUrl" alt="avatar" />
                                <div v-else>
                                <loading-outlined v-if="imgLoading"></loading-outlined>
                                <plus-outlined v-else></plus-outlined>
                                <div class="ant-upload-text">上传</div>
                                </div>
                            </a-upload>
                        </a-form-item>
                        <a-form-item label="微信公众号">
                            <a-upload
                                name="avatar"
                                list-type="picture-card"
                                class="avatar-uploader"
                                :show-upload-list="false"
                                :action="baseUrl+'/agent/PushImg'" :custom-request="ossDirectUpload"
                                @change="weChatPublicHandleChange"
                                accept="image/jpeg,image/png">
                                <img style="width:100%;height:100%" v-if="config.weChatPublicUrl" :src="config.weChatPublicUrl" alt="avatar" />
                                <div v-else>
                                <loading-outlined v-if="imgLoading"></loading-outlined>
                                <plus-outlined v-else></plus-outlined>
                                <div class="ant-upload-text">上传</div>
                                </div>
                            </a-upload>
                        </a-form-item>
                        
                       
                        <a-form-item style="text-align: center;">
                            <a-button type="primary" @click="setConfigOk">保存</a-button>
                        </a-form-item>
                    </a-form>
                </a-card>
            </a-col>
        </a-row>

        <a-modal :confirmLoading="operateing"  v-model:visible="zhuanVisible" title="转账"  style="width:400px" @ok="zhuanOk"  ok-text="确认" cancel-text="取消">
            <a-alert message="请先查询对方信息核对后转账" type="info" show-icon />
            <a-input-search
            :loading="operateing"
            style="margin-top:20px;"
      v-model:value="zhuanMondel.walletId"
      placeholder="请输入对方钱包Id"
      enter-button
      @search="onSearch"
    />
            <a-row style="margin-top:20px;margin-bottom: 20px;">
                <a-col :span="12">
                    <a-tag>名称</a-tag>
                    {{ target.name }}
                </a-col>
 
                <a-col :span="12">
                    <a-tag>账号</a-tag>
                    {{ target.phone }}
                </a-col>

            </a-row>

            <a-input-number :min="1" :max="999999" v-model:value="zhuanMondel.money" prefix="￥" style="width: 100%;">
                <template #addonBefore>
                    转账金额
                </template>
            </a-input-number>
        </a-modal>


        <a-modal :confirmLoading="operateing"  v-model:visible="visible" title="提现"  style="width:400px" @ok="ok"  ok-text="确认" cancel-text="取消">
            <a-form
            ref="formRef"
                :model="model"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 16 }"
                autocomplete="off">
                <a-form-item
                label="类型"
                name="Type"
                >
                    <a-radio-group v-model:value="type">
                        <a-radio :value="1">支付宝</a-radio>
                        <a-radio :value="2">银行卡</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item
                label="账户名称"
                name="accountName"
                :rules="[{ required: true, message: '请输入账户名称' }]"
                >
                <a-input v-model:value="model.accountName" />
                </a-form-item>

                <a-form-item
                :label="type==1?'支付宝账号':'银行卡号'"
                name="account"
                :rules="[{ required: true, message: '请输入支付宝账号 / 银行卡号' }]"
                >
                    <a-input v-model:value="model.account" />
                </a-form-item>

                <a-form-item
                v-show="type==2"
                label="开户行"
                name="bank"
                >
                <a-input v-model:value="model.bank" />
                </a-form-item>
                

            </a-form>
        </a-modal>
    </div>
</template>
<script>
import { ref} from 'vue';
import { agentGetMyReq,agentGetIndex,agentWithdrawReq,agentGetFundsReq,uri,agentSetConfigReq,agentGetTargetReq,agentTransferReq } from '@/request.js';
import { message } from 'ant-design-vue';

import { ShopOutlined,TeamOutlined,FlagOutlined,PlusOutlined,LoadingOutlined } from '@ant-design/icons-vue';
export default ({
    components: {
        ShopOutlined,TeamOutlined,FlagOutlined,PlusOutlined,LoadingOutlined
    },
    setup() {
        const baseUrl=ref(uri);
        const imgLoading=ref(false);
        const config=ref({
            domain:"",
            siteName:"",
            service:"",
            weChatUrl:"",
            weChatPublicUrl:"",
            invitationUrl:"",
            invitationCode:""
        });
        const target=ref({
            name:"",
            phone:""
        })
        const loading=ref(false);
        const list=ref([]);
        const pagination=ref({
            total: 0,
            pageSize: 5,
            showSizeChanger: false,
            showTotal: total => `共 ${total} 条`,  
        });
        const operateing=ref(false);
        const type=ref(1);
        const model=ref({
            account:"",
            accountName:"",
            bank:""
        })
        const zhuanVisible=ref(false);
        const zhuanMondel=ref({
            walletId:"",
            money:1
        });
        const index=ref({});
        const getIndex=()=>{
            agentGetIndex({},(res)=>{
                index.value=res.Result;
                config.value.domain=res.Result.Domin;
                config.value.siteName=res.Result.SiteName;
                config.value.service=res.Result.Service;
                config.value.weChatUrl=res.Result.WeChatUrl;
                config.value.weChatPublicUrl=res.Result.WeChatPublicUrl;
                config.value.invitationCode=res.Result.InvitationCode;
                config.value.invitationUrl=res.Result.InvitationUrl;
            });
        }
        getIndex();
        const commissionList=ref([]);
        agentGetMyReq({},(res)=>{
            commissionList.value=res.Result;
        })
        const visible=ref(false);
        const withdraw=()=>{
            model.value={
                account:"",
                accountName:"",
                bank:""
            };
            visible.value=true;  
        };

        const query=(index)=>{
            loading.value=true;
            agentGetFundsReq({
                pIndex:index,
                pSize:pagination.value.pageSize,
            },(res)=>{
                list.value=res.Result;
                pagination.value.total=res.TotalCount;
                loading.value=false;
            })
        };
        const handleTableChange=(e)=>{
            query(e.current);
        };
        const setConfigOk=()=>{
            operateing.value=true;
            agentSetConfigReq(config.value,(res)=>{
                if(res.IsSuccess){
                    message.success("保存成功");

                }else{
                    message.error("系统错误");
                }
                operateing.value=false;
            })
        }
        const zhuanOk=()=>{
            if(zhuanMondel.value.walletId.length<5){
                message.error("请输入正确的钱包ID")
            }else{
                if(target.value){
                    operateing.value=true;
                    agentTransferReq(zhuanMondel.value,(res)=>{
                        if(res.IsSuccess){
                            zhuanVisible.value=false;
                            getIndex();
                            message.success("转账成功")
                        }else{
                            message.error(res.Message);
                        }
                        operateing.value=false;
                    })
                }else{
                    message.error("请先查询对方信息")
                }
            }
        }
        const weChatHandleChange = info => {
            if (info.file.status === 'uploading') {
                imgLoading.value = true;
                return;
            }
            if (info.file.status === 'done') {
                if(info.file.response.IsSuccess){
                    config.value.weChatUrl=info.file.response.Message;
                }else{
                    message.error('上传失败');
                }
                imgLoading.value = false;
            }
            if (info.file.status === 'error') {
                imgLoading.value = false;
                message.error('上传失败');
            }
        };
        const weChatPublicHandleChange = info => {
            if (info.file.status === 'uploading') {
                imgLoading.value = true;
                return;
            }
            if (info.file.status === 'done') {
                if(info.file.response.IsSuccess){
                    config.value.weChatPublicUrl=info.file.response.Message;
                }else{
                    message.error('上传失败');
                }
                imgLoading.value = false;
            }
            if (info.file.status === 'error') {
                imgLoading.value = false;
                message.error('上传失败');
            }
        };
        const zhuanAction=()=>{
            zhuanVisible.value=true;
            target.value={};
        }
        const onSearch=()=>{
            if(zhuanMondel.value.walletId.length<5){
                message.error("请输入正确的钱包ID")
            }else{
                operateing.value=true;
                agentGetTargetReq({walletId:zhuanMondel.value.walletId},(res)=>{
                    if(res.IsSuccess){
                        target.value.name=res.Result.Name;
                        target.value.phone=res.Result.Phone;
                    }else{
                        message.error(res.Message);
                    }
                    operateing.value=false;
                })
            }

        }
        const ok=()=>{
            operateing.value=true;
            agentWithdrawReq(model.value,(res)=>{
                if(res.IsSuccess){
                    index.value.Balance=0;
                    message.success("提现成功，请等待审核");
                }else{
                    message.error(res.Message);
                }
                operateing.value=false;
            })
        }
        query(1);
        return{
            target,
            onSearch,
            zhuanOk,
            zhuanVisible,
            zhuanMondel,
            zhuanAction,
            setConfigOk,
            weChatPublicHandleChange,
            weChatHandleChange,
            baseUrl,
            imgLoading,
            config,
            handleTableChange,
            loading,
            list,
            pagination,
            operateing,
            type,
            ok,
            visible,
            model,
            withdraw,
            index,
            labelCol: {
                style: {
                width: '100px',
                },
            },
            commissionList,
            columns:[
                {
                    title: '账户名',
                    dataIndex: 'AccountName',
                    key: 'accountName',
                },
                {
                    title: '支付宝账号 / 银行卡号',
                    dataIndex: 'CardNo',
                    key: 'cardNo',
                },
                {
                    title: '开户行',
                    dataIndex: 'AccountBankName',
                    key: 'accountBankName',
                },
                {
                    title: '金额',
                    dataIndex: 'MoneyText',
                    key: 'moneyText',
                },
                {
                    title: '状态',
                    dataIndex: 'Status',
                    key: 'status',
                },
                {
                    title: '申请时间',
                    dataIndex: 'CreateTime',
                    key: 'createTime',
                },
            ]
        }
    },
})
</script>
